import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-rules-modal',
  templateUrl: './rules-modal.page.html',
  styleUrls: ['./rules-modal.page.scss'],
})
export class RulesModalPage implements OnInit {

  constructor(private modalcontroler:ModalController) { }

  ngOnInit() {
  }
  onClosepage(){
 
    this.modalcontroler.dismiss()
  }
}
